import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Calendar, Info } from "lucide-react";

const EventPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasSeenPopup = sessionStorage.getItem("event_popup_seen");
    if (!hasSeenPopup) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem("event_popup_seen", "true");
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-[700px] bg-[#0a0a0a] border border-[#d4af37]/30 text-white overflow-y-auto max-h-[90vh]">
        <DialogHeader className="space-y-4">
          <div className="flex justify-center mb-2">
            <div className="p-3 rounded-full bg-[#d4af37]/10 border border-[#d4af37]/20">
              <Calendar className="w-8 h-8 text-[#d4af37]" />
            </div>
          </div>
          <DialogTitle className="text-2xl md:text-3xl font-serif text-center text-[#d4af37] tracking-wider uppercase">
            FONTOS KÖZLEMÉNY: ÚJ IDŐPONT
          </DialogTitle>
          <div className="w-24 h-px bg-[#d4af37]/50 mx-auto"></div>
        </DialogHeader>
        
        <div className="mt-6 space-y-6 text-gray-300 font-sans leading-relaxed text-sm md:text-base px-2">
          <p className="italic text-center text-[#d4af37]/80">
            ✧ A CXCIV. Budapesti Jogász- és Vállalkozóbál szervezőiként fontos számunkra, hogy rendezvényünk minden körülmények között méltó módon valósuljon meg – mind a hagyományaihoz, mind a résztvevő közösséghez.
          </p>

          <p>
            A 2026. május 9-re eső időpont kapcsán olyan, az egész országot érintő, kiemelt jelentőségű eseményre kerül sor, mint az <strong>Országgyűlés alakuló ülése</strong>, ahol az új Országgyűlés megválasztja az új miniszterelnököt. Vendégeink jelentős része szakmai vagy személyes okokból érintett ebben a történelmi pillanatban, illetve sokan úgy érzik, hogy ezen az eseményen szeretnének jelen lenni.
          </p>

          <p>
            Tekintettel arra, hogy a Budapesti Jogászbál közössége és szellemisége szorosan kapcsolódik a közélethez, valamint arra a szándékunkra, hogy a már felállt új kormány tagjait is meghívhassuk a rendezvényre, felelős döntést hoztunk.
          </p>

          <div className="bg-[#111] border-l-2 border-[#d4af37] p-6 my-8 text-center">
            <p className="text-xs uppercase tracking-[0.2em] text-[#d4af37]/60 mb-2">A bál új időpontja:</p>
            <p className="text-3xl md:text-4xl font-serif font-bold text-white tracking-widest">2027. február 20.</p>
          </div>

          <p>
            Az elmúlt napokban igyekeztünk mindenkit szóban és személyesen, telefonon is értesíteni a változásról, és ezúton is köszönjük szépen a megértést és a támogatást. A hivatalos értesítést e-mailben is megküldjük. Amennyiben az új időpont Önöknek nem megfelelő, kérjük, jelezzék számunkra, és a részvételi díjat természetesen visszatérítjük.
          </p>

          <p>
            Bízunk benne, hogy ezzel a döntéssel egy még erősebb, még emlékezetesebb estét tudunk majd közösen megvalósítani.
          </p>
          
          <div className="pt-4 border-t border-white/10">
            <p className="font-serif text-[#d4af37] font-bold">A Budapesti Jogászbál szervezőbizottsága</p>
            <div className="flex flex-wrap gap-2 mt-4 opacity-50 text-[10px] uppercase tracking-widest">
              <span>#budapestijogaszbal</span>
              <span>#jogaszbal</span>
              <span>#budapest</span>
              <span>#bál</span>
              <span>#ujidopont</span>
            </div>
          </div>
        </div>

        <DialogFooter className="mt-8 flex flex-col sm:flex-row gap-4 justify-center items-center border-t border-white/10 pt-6">
          <Button 
            onClick={handleClose}
            className="w-full sm:w-auto bg-[#d4af37] text-black hover:bg-[#c4a130] font-bold uppercase tracking-widest px-12 py-6 rounded-none transition-all duration-300"
          >
            Értettem
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EventPopup;
